<template>
  <div>
    <div class="header-row">
      <hilo-button styleType="back" />
      <div>
        <hilo-button
          label="Print"
          style="margin-right: 10px"
          @click="printPage"
        />
        <hilo-button
          type="submit"
          styleType="submit"
          label="Save and Send"
          @click="submitForm"
        />
      </div>
    </div>
    <div class="print-content">
      <div class="print-header" v-html="getPrintHeader()"></div>
      <h4 class="black-banner">
        {{ isEditMode ? "" : "New " }} Quote for {{ this.$route.params.name }}
      </h4>
      <section class="pricing-table" v-if="quote">
        <table>
          <tr>
            <th>Certificate</th>
            <th>Flight Hours</th>
            <th>Price</th>
            <th>Ground Hours</th>
            <th>Notes</th>
          </tr>
          <tbody class="section">
            <tr>
              <td>Private</td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.privateFlightHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'privatePrice'
                      ? quote.privatePrice
                      : formatCurrency(quote.privatePrice)
                  "
                  @focus="removeFormatting('privatePrice')"
                  @blur="applyFormatting('privatePrice')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'privatePrice')"
                  class="green-background"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.privateGroundHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="quote.privateNotes"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
            </tr>
            <tr>
              <td>Instrument</td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.instrumentFlightHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'instrumentPrice'
                      ? quote.instrumentPrice
                      : formatCurrency(quote.instrumentPrice)
                  "
                  @focus="removeFormatting('instrumentPrice')"
                  @blur="applyFormatting('instrumentPrice')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'instrumentPrice')"
                  class="green-background"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.instrumentGroundHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="quote.instrumentNotes"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
            </tr>
            <tr>
              <td>Commercial</td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.commercialFlightHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'commercialPrice'
                      ? quote.commercialPrice
                      : formatCurrency(quote.commercialPrice)
                  "
                  @focus="removeFormatting('commercialPrice')"
                  @blur="applyFormatting('commercialPrice')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'commercialPrice')"
                  class="green-background"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.commercialGroundHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="quote.commercialNotes"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
            </tr>
            <tr>
              <td>CFI</td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.cfiFlightHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'cfiPrice'
                      ? quote.cfiPrice
                      : formatCurrency(quote.cfiPrice)
                  "
                  @focus="removeFormatting('cfiPrice')"
                  @blur="applyFormatting('cfiPrice')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'cfiPrice')"
                  class="green-background"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.cfiGroundHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="quote.cfiNotes"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
            </tr>
            <tr>
              <td>CFII</td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.cfiiFlightHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'cfiiPrice'
                      ? quote.cfiiPrice
                      : formatCurrency(quote.cfiiPrice)
                  "
                  @focus="removeFormatting('cfiiPrice')"
                  @blur="applyFormatting('cfiiPrice')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'cfiiPrice')"
                  class="green-background"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.cfiiGroundHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="quote.cfiiNotes"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
            </tr>
            <tr>
              <td>Comm Multi</td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.commMultiFlightHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'commMultiPrice'
                      ? quote.commMultiPrice
                      : formatCurrency(quote.commMultiPrice)
                  "
                  @focus="removeFormatting('commMultiPrice')"
                  @blur="applyFormatting('commMultiPrice')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'commMultiPrice')"
                  class="green-background"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.commMultiGroundHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="quote.commMultiNotes"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
            </tr>
            <tr>
              <td>MEI</td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.meiFlightHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'meiPrice'
                      ? quote.meiPrice
                      : formatCurrency(quote.meiPrice)
                  "
                  @focus="removeFormatting('meiPrice')"
                  @blur="applyFormatting('meiPrice')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'meiPrice')"
                  class="green-background"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.meiGroundHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="quote.meiNotes"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
            </tr>
          </tbody>
          <tr>
            <th>Team Building & Sim</th>
            <th></th>
            <th></th>
            <th colspan="2">Notes</th>
          </tr>
          <tbody class="section">
            <tr>
              <td>Crew Flight</td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.crewFlightHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'crewPrice'
                      ? quote.crewPrice
                      : formatCurrency(quote.crewPrice)
                  "
                  @focus="removeFormatting('crewPrice')"
                  @blur="applyFormatting('crewPrice')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'crewPrice')"
                  class="green-background"
                />
              </td>
              <td colspan="2">
                <input
                  type="text"
                  v-model="quote.crewNotes"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
            </tr>
            <tr>
              <td>Sim Hrs</td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.simFlightHours"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'simPrice'
                      ? quote.simPrice
                      : formatCurrency(quote.simPrice)
                  "
                  @focus="removeFormatting('simPrice')"
                  @blur="applyFormatting('simPrice')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'simPrice')"
                  class="green-background"
                />
              </td>
              <td colspan="2">
                <input
                  type="text"
                  v-model="quote.simNotes"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
            </tr>
          </tbody>
          <tr>
            <th>Other Fees</th>
            <th>Tests</th>
            <th></th>
            <th colspan="2">Price Per Test</th>
          </tr>
          <tbody class="section">
            <tr>
              <td>Checkride Fees</td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.checkrideTests"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>{{ formatCurrency(checkrideFeesTotal) }}</td>
              <td colspan="2">
                <input
                  type="text"
                  :value="
                    focusedField === 'checkridePricePerTest'
                      ? quote.checkridePricePerTest
                      : formatCurrency(quote.checkridePricePerTest)
                  "
                  @focus="removeFormatting('checkridePricePerTest')"
                  @blur="applyFormatting('checkridePricePerTest')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'checkridePricePerTest')"
                  class="yellow-background"
                />
              </td>
            </tr>
            <tr>
              <td>Knowledge Test Fees</td>
              <td>
                <input
                  type="number"
                  v-model.number="quote.knowledgeTests"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
              <td>{{ formatCurrency(knowledgeTestFeesTotal) }}</td>
              <td colspan="2">
                <input
                  type="text"
                  :value="
                    focusedField === 'knowledgePricePerTest'
                      ? quote.knowledgePricePerTest
                      : formatCurrency(quote.knowledgePricePerTest)
                  "
                  @focus="removeFormatting('knowledgePricePerTest')"
                  @blur="applyFormatting('knowledgePricePerTest')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'knowledgePricePerTest')"
                  class="yellow-background"
                />
              </td>
            </tr>
            <tr>
              <td>Reserve</td>
              <td></td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'reserveAmount'
                      ? quote.reserveAmount
                      : formatCurrency(quote.reserveAmount)
                  "
                  @focus="removeFormatting('reserveAmount')"
                  @blur="applyFormatting('reserveAmount')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'reserveAmount')"
                  class="green-background"
                />
              </td>
              <td colspan="2">
                <input
                  type="text"
                  v-model="quote.reserveNote"
                  class="yellow-background"
                  @keydown="handleKeydown($event)"
                />
              </td>
            </tr>
          </tbody>
          <tr>
            <th>Totals</th>
            <th colspan="4"></th>
          </tr>
          <tbody class="section">
            <tr>
              <td>Total Flight Hours</td>
              <td colspan="4">{{ totalFlightHours }}</td>
            </tr>
            <tr>
              <td>Total Ground Hours</td>
              <td colspan="4">{{ totalGroundHours }}</td>
            </tr>
            <tr>
              <td>Total Sim Hours</td>
              <td colspan="4">{{ quote.simFlightHours }}</td>
            </tr>
          </tbody>
          <tr>
            <th>Courses Included</th>
            <th colspan="4"></th>
          </tr>
          <tbody class="section">
            <tr>
              <td>Course</td>
              <td colspan="4">
                <input
                  type="text"
                  v-model="quote.courseIncluded"
                  class="yellow-background wider-input"
                  @keydown="handleKeydown($event)"
                />
              </td>
            </tr>
          </tbody>
          <tr>
            <th>Living Expenses</th>
            <th>Payment 1</th>
            <th>Payment 2</th>
            <th>Payment 3</th>
            <th>Total</th>
          </tr>
          <tbody class="section section-living-expenses">
            <tr>
              <td>Stipend</td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'stipendPayment1'
                      ? quote.stipendPayment1
                      : formatCurrency(quote.stipendPayment1)
                  "
                  @focus="removeFormatting('stipendPayment1')"
                  @blur="applyFormatting('stipendPayment1')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'stipendPayment1')"
                  class="yellow-background"
                />
              </td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'stipendPayment2'
                      ? quote.stipendPayment2
                      : formatCurrency(quote.stipendPayment2)
                  "
                  @focus="removeFormatting('stipendPayment2')"
                  @blur="applyFormatting('stipendPayment2')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'stipendPayment2')"
                  class="yellow-background"
                />
              </td>
              <td>
                <input
                  type="text"
                  :value="
                    focusedField === 'stipendPayment3'
                      ? quote.stipendPayment3
                      : formatCurrency(quote.stipendPayment3)
                  "
                  @focus="removeFormatting('stipendPayment3')"
                  @blur="applyFormatting('stipendPayment3')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'stipendPayment3')"
                  class="yellow-background"
                />
              </td>
              <td>{{ formatCurrency(totalStipend) }}</td>
            </tr>
            <tr>
              <td>Monthly Housing</td>
              <td colspan="4">
                <input
                  type="text"
                  :value="
                    focusedField === 'monthlyHousing'
                      ? quote.monthlyHousing
                      : formatCurrency(quote.monthlyHousing)
                  "
                  @focus="removeFormatting('monthlyHousing')"
                  @blur="applyFormatting('monthlyHousing')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'monthlyHousing')"
                  class="yellow-background"
                />
              </td>
            </tr>
          </tbody>
          <tr>
            <th>Funding Paid</th>
            <th colspan="4"></th>
          </tr>
          <tbody class="section">
            <tr>
              <td>Seat Charge</td>
              <td colspan="4">
                <input
                  type="text"
                  :value="
                    focusedField === 'seatCharge'
                      ? quote.seatCharge
                      : formatCurrency(quote.seatCharge)
                  "
                  @focus="removeFormatting('seatCharge')"
                  @blur="applyFormatting('seatCharge')"
                  @keydown="handleKeydown($event)"
                  @input="updatePrice($event, 'seatCharge')"
                  class="yellow-background"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <h5 class="black-banner">
        <span class="label">Tuition Amount:</span>
        <span>{{ formatCurrency(totalProgramPrice) }}</span>
        <span class="label">Total Price Due:</span>
        <span class="green">{{ formatCurrency(totalPriceDue) }}</span>
        <span class="label">Grand Total:</span>
        <span class="yellow">{{ formatCurrency(grandTotal) }}</span>
      </h5>
      <h5 class="black-banner">
        <span class="label">Upfront (35%):</span>
        <span class="red">{{ formatCurrency(upfrontAmount) }}</span>
        <span class="label">After Private (35%):</span>
        <span class="red">{{ formatCurrency(afterPrivateAmount) }}</span>
        <span class="label">After Instrument (30%):</span>
        <span class="red">{{ formatCurrency(afterInstrumentAmount) }}</span>
      </h5>
      <div class="print-footer" v-html="getPrintFooter()"></div>
    </div>
  </div>
</template>

<script>
import QuotesAPIService from "src/servicehandlers/QuotesAPIService.js";
import HiloButton from "../../../../components/HiloComponents/HiloButton.vue";
import html2pdf from "html2pdf.js";
import { formatCurrency } from "@/util/currency";

const quotesAPIService = new QuotesAPIService();

export default {
  name: "QuoteComponent",
  components: { HiloButton },
  data() {
    return {
      isEditMode: false,
      loading: true,
      focusedField: null,
      quote: {
        privateFlightHours: 0,
        privatePrice: 0,
        privateGroundHours: 0,
        privateNotes: "",
        instrumentFlightHours: 0,
        instrumentPrice: 0,
        instrumentGroundHours: 0,
        instrumentNotes: "",
        commercialFlightHours: 0,
        commercialPrice: 0,
        commercialGroundHours: 0,
        commercialNotes: "",
        cfiFlightHours: 0,
        cfiPrice: 0,
        cfiGroundHours: 0,
        cfiNotes: "",
        cfiiFlightHours: 0,
        cfiiPrice: 0,
        cfiiGroundHours: 0,
        cfiiNotes: "",
        commMultiFlightHours: 0,
        commMultiPrice: 0,
        commMultiGroundHours: 0,
        commMultiNotes: "",
        meiFlightHours: 0,
        meiPrice: 0,
        meiGroundHours: 0,
        meiNotes: "",
        crewFlightHours: 0,
        crewPrice: 0,
        crewNotes: "",
        simFlightHours: 0,
        simPrice: 0,
        simNotes: "",
        checkridePricePerTest: 0,
        checkrideTests: 0,
        knowledgePricePerTest: 0,
        knowledgeTests: 0,
        reserveAmount: 0,
        reserveNote: "",
        courseIncluded: "",
        stipendPayment1: 0,
        stipendPayment2: 0,
        stipendPayment3: 0,
        monthlyHousing: 0,
        seatCharge: 0,
        image: "",
      },
    };
  },
  computed: {
    totalFlightHours() {
      if (!this.quote) return 0;
      return (
        Number(this.quote.privateFlightHours) +
        Number(this.quote.instrumentFlightHours) +
        Number(this.quote.commercialFlightHours) +
        Number(this.quote.cfiFlightHours) +
        Number(this.quote.cfiiFlightHours) +
        Number(this.quote.commMultiFlightHours) +
        Number(this.quote.meiFlightHours) +
        Number(this.quote.crewFlightHours)
      );
    },

    totalGroundHours() {
      if (!this.quote) return 0;
      return (
        Number(this.quote.privateGroundHours) +
        Number(this.quote.instrumentGroundHours) +
        Number(this.quote.commercialGroundHours) +
        Number(this.quote.cfiGroundHours) +
        Number(this.quote.cfiiGroundHours) +
        Number(this.quote.commMultiGroundHours) +
        Number(this.quote.meiGroundHours)
      );
    },
    checkrideFeesTotal() {
      if (!this.quote) return 0;
      return (
        this.quote.checkridePricePerTest * this.quote.checkrideTests
      ).toFixed(2);
    },
    knowledgeTestFeesTotal() {
      if (!this.quote) return 0;
      return (
        this.quote.knowledgePricePerTest * this.quote.knowledgeTests
      ).toFixed(2);
    },
    totalStipend() {
      if (!this.quote) return 0;
      return (
        parseFloat(String(this.quote.stipendPayment1) || 0) +
        parseFloat(String(this.quote.stipendPayment2) || 0) +
        parseFloat(String(this.quote.stipendPayment3) || 0)
      ).toFixed(2);
    },
    totalProgramPrice() {
      return (
        (parseFloat(this.quote.privatePrice) || 0) +
        (parseFloat(this.quote.instrumentPrice) || 0) +
        (parseFloat(this.quote.commercialPrice) || 0) +
        (parseFloat(this.quote.cfiPrice) || 0) +
        (parseFloat(this.quote.cfiiPrice) || 0) +
        (parseFloat(this.quote.commMultiPrice) || 0) +
        (parseFloat(this.quote.meiPrice) || 0) +
        (parseFloat(this.quote.crewPrice) || 0) +
        (parseFloat(this.quote.simPrice) || 0)
      );
    },
    totalPriceDue() {
      return (
        (parseFloat(this.totalProgramPrice) || 0) +
        (parseFloat(this.checkrideFeesTotal) || 0) +
        (parseFloat(this.knowledgeTestFeesTotal) || 0) +
        (parseFloat(this.quote.reserveAmount) || 0)
      );
    },
    grandTotal() {
      return (
        parseFloat(this.totalPriceDue) +
        parseFloat(this.totalStipend) +
        parseFloat(this.quote.monthlyHousing) +
        parseFloat(this.quote.seatCharge)
      );
    },
    upfrontAmount() {
      return parseFloat(this.grandTotal) * 0.35;
    },
    afterPrivateAmount() {
      return parseFloat(this.grandTotal) * 0.35;
    },
    afterInstrumentAmount() {
      return (
        parseFloat(this.grandTotal) -
        parseFloat(this.upfrontAmount) -
        parseFloat(this.afterPrivateAmount)
      );
    },
  },
  methods: {
    formatCurrency,
    async getDefaultQuote() {
      return quotesAPIService
        .getDefault()
        .then((response) => {
          this.quote = response;
        })
        .catch((error) => {
          this.error_txt = "Failed to get default quote: " + error;
        });
    },
    async getQuote(quoteId) {
      return quotesAPIService
        .getById(quoteId)
        .then((response) => {
          this.quote = response;
        })
        .catch((error) => {
          this.error_txt = "Failed to get quote by id: " + error;
        });
    },
    printPage() {
      window.print();
    },
    removeFormatting(field) {
      this.focusedField = field;
      this.$nextTick(() => {
        const activeElement = document.activeElement;
        if (activeElement && activeElement.tagName === "INPUT") {
          activeElement.select();
        }
      });
    },
    applyFormatting(field) {
      this.focusedField = null;
      if (this.quote[field]) {
        this.quote[field] = parseFloat(this.quote[field]) || 0;
      }
    },
    updatePrice(event, field) {
      const input = event.target.value.replace(/[^0-9.]/g, "");
      this.quote[field] = parseFloat(input) || 0;
    },
    handleKeydown(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        const currentField = event.target;

        currentField.blur();

        const allInputs = Array.from(
          document.querySelectorAll("input, textarea"),
        );
        const currentIndex = allInputs.indexOf(currentField);

        if (currentIndex >= 0 && currentIndex < allInputs.length - 1) {
          const nextInput = allInputs[currentIndex + 1];
          if (nextInput) {
            nextInput.focus();
            nextInput.select();
          }
        }
      }
    },
    async submitForm() {
      try {
        document.body.style.overflowY = "hidden";
        this.quote.image = await this.createPdf();
        if (this.isEditMode) {
          await quotesAPIService.update(this.$route.params.id, this.quote);
        } else {
          const quoteWithoutDefaultQuoteId = {
            ...this.quote,
            studentName: this.$route.params.name,
          };
          delete quoteWithoutDefaultQuoteId.id;
          await quotesAPIService.create(
            this.$route.params.potentialStudentId,
            quoteWithoutDefaultQuoteId,
          );
        }
      } catch (error) {
      } finally {
        document.body.style.overflowY = "auto";
        this.$router.back();
      }
    },
    getPrintHeader() {
      return `
        <img src="/static/img/v-w-airplane-logo.png" alt="Airplane Logo" style="width: 150px; height: auto;" />
        <h4 style="background-color: maroon; color: white; padding: 2px;">Airline Academy Program Price</h4>
        <h5 style="font-style: italic;">
          Below is the quoted price for your program. You will need to review and confirm this <b>Total</b> price.
          The allotted hours and schedule are as follows. Any time exceeding these allocated hours will incur additional charges at a per hour rate.
        </h5>
        `;
    },
    getPrintFooter() {
      return `
        <div style="display: flex; justify-content: space-between; margin: 0 70px;">
          <div style="width: 400px; text-align: left;">
            <span>Student Name: ${this.$route.params.name}</span>
          </div>
          <div style="width: 300px; text-align: left;">
            <span>Previous Hours: ${this.$route.params.previousHours}</span>
          </div>
        </div>

        <div style="display: flex; justify-content: space-between; margin: 10px 70px 0;">
          <div style="width: 400px; text-align: left;">
            <span>Student Signature:</span>
            <span style="border-bottom: 1px solid black; width: 57%; display: inline-block;"></span>
          </div>
          <div style="width: 300px; text-align: left;">
            <span>Date:</span>
            <span style="border-bottom: 1px solid black; width: 80%; display: inline-block;"></span>
          </div>
        </div>

        <div style="display: flex; justify-content: space-between; margin: 10px 70px 0;">
          <div style="width: 400px; text-align: left;">
            <span>VW Executive Signature:</span>
            <span style="border-bottom: 1px solid black; width: 51%; display: inline-block;"></span>
          </div>
          <div style="width: 300px; text-align: left;">
            <span>Date:</span>
            <span style="border-bottom: 1px solid black; width: 80%; display: inline-block;"></span>
          </div>
        </div>

        <h5 style="font-style: italic; margin-top: 20px;">
          All the hours mentioned above are categorized as dual instruction hours, indicating that you are billed for the instructor's
          time while receiving valuable instruction. Crew flights will be conducted with another student. Examiner fees may vary, and any
          additional charges imposed by an examiner will be the responsibility of the student. Unfortunately, Venture West has no control over
          the examiner's fee structure. If a student chooses to defer their spot in the checkride queue to await a lower examiner fee, they
          are welcome to do so. Additionally, fees incurred from a discontinuance or a disapproval will have to be covered by the student.
          Also, any disbursement of funds to Venture West, including the initial upfront payment, subsequent payment after private, or the final
          payment following instrument--all funds released either by the student directly or by a financial institution on the student's
          behalf--will be non-refundable.
        </h5>

        <h5 style="font-style: italic; font-weight: bold; margin-top: 20px;">Tyler (480) 828-8313 Bud (615) 425-6111</h5>
      `;
    },
    async createPdf() {
      const iframe = document.createElement("iframe");
      document.body.appendChild(iframe);

      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

      const wrapper = iframeDoc.createElement("div");
      const element = document.querySelector(".print-content").cloneNode(true);
      wrapper.appendChild(element);

      const printHeader = iframeDoc.createElement("div");
      printHeader.innerHTML = this.getPrintHeader();
      printHeader.classList.add("print-header");
      element.prepend(printHeader);

      const printFooter = iframeDoc.createElement("div");
      printFooter.innerHTML = this.getPrintFooter();
      printFooter.classList.add("print-footer");
      element.append(printFooter);

      iframeDoc.body.appendChild(wrapper);

      iframeDoc.querySelectorAll(".black-banner").forEach((el) => {
        el.style.fontSize = "12px";
        el.querySelectorAll("span").forEach(
          (span) => (span.style.marginRight = "10px"),
        );
      });
      iframeDoc.querySelectorAll("table").forEach((el) => {
        el.style.fontSize = "12px";
      });
      iframeDoc
        .querySelectorAll(".print-header, .print-footer")
        .forEach((el) => {
          el.style.textAlign = "center";
          el.style.fontSize = "12px";
          el.querySelectorAll("h4").forEach((h4) => {
            h4.style.fontSize = "14px";
          });
          el.querySelectorAll("h5").forEach((h5) => {
            h5.style.fontSize = "12px";
          });
        });

      const options = {
        margin: [5, 10, 5, 10],
        filename: "quote.pdf",
        html2canvas: { scale: 3 },
        jsPDF: {
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        },
      };

      const pdfBlob = await html2pdf()
        .set(options)
        .from(iframeDoc.body)
        .output("blob");

      document.body.removeChild(iframe);

      return new File([pdfBlob], "quote.pdf", { type: "application/pdf" });
    },
  },
  async created() {
    if (this.$route.params.id) {
      this.isEditMode = true;
      await this.getQuote(this.$route.params.id);
    } else {
      await this.getDefaultQuote();
    }
    this.loading = false;
  },
};
</script>

<style scoped>
.header-row {
  display: flex;
  justify-content: space-between;
}

.black-banner {
  background-color: black;
  color: white;
  margin-top: 10px;
  padding: 2px 0;
  text-align: center;
}

.black-banner span {
  margin-right: 120px;
}

.black-banner .label {
  margin-right: 20px;
}

.black-banner .yellow {
  color: yellow;
}

.black-banner .green {
  color: #32cd32;
}

.black-banner .red {
  color: red;
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  font-size: 14px;
}

table .section {
  border: 2px solid black;
}

table th,
table td {
  padding: 1px;
}

table th {
  background-color: white;
  color: black;
  border: none;
}

table td:first-child,
table td:nth-child(3) {
  background-color: #a9d083;
}

.wider-input {
  width: 250px;
}

.green-background,
.yellow-background {
  border: none;
  text-align: center;
}

.green-background:focus,
.yellow-background:focus {
  border: 1px solid #000;
}

.green-background {
  background-color: #a9d083;
}

.yellow-background {
  background-color: lightgoldenrodyellow;
}

table td:nth-child(2),
table td:nth-child(4),
table td:nth-child(5),
table .section-living-expenses td:nth-child(3) {
  background-color: lightgoldenrodyellow;
}

@media print {
  @page {
    size: auto;
    margin: 20px;
  }

  header,
  footer {
    display: none !important;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .header-row {
    display: none;
  }

  .black-banner {
    font-size: 14px !important;
  }

  .black-banner span {
    margin-right: 10px !important;
  }

  table {
    font-size: 12px !important;
  }

  .print-header,
  .print-footer {
    display: block;
    text-align: center;
    margin: 20px 0;
  }

  .pricing-table {
    page-break-before: always;
  }
}

@media screen {
  .print-header,
  .print-footer {
    display: none;
  }
}
</style>
